import { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";

import Modal from "../common/Modal";
import Backdrop from "../common/modal/Backdrop";
import Button from "../common/Button";
import classes from './BrowserPermission.module.css';
export default function BrowserPermission() {
    const [permissionState, setPermissionState] = useState("unknown");
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState(null);

    const overlayRoot = useMemo(() => document.getElementById("overlay-root"), []);
    const backdropRoot = useMemo(() => document.getElementById("backdrop-root"), []);

    useEffect(() => {
        let status = null;
        let cancelled = false;

        async function run() {
            setError(null);

            if (!navigator?.permissions?.query) {
                if (!cancelled) {
                    setPermissionState("unsupported");
                    if (process.env.REACT_APP_TEST_ENV !== 'development') {
                        setShowModal(true);
                    }
                    setError("Your browser doesn't support checking this permission automatically.");
                }
                return;
            }

            try {
                status = await navigator.permissions.query({ name: "local-network-access" });

                if (cancelled) return;

                setPermissionState(status.state);
                if (process.env.REACT_APP_TEST_ENV !== 'development') {
                    setShowModal(status.state !== "granted");
                }

                status.onchange = () => {
                    if (cancelled) return;
                    setPermissionState(status.state);
                    if (process.env.REACT_APP_TEST_ENV !== 'development') {
                        setShowModal(status.state !== "granted");
                    }
                };
            } catch (e) {
                if (!cancelled) {
                    setPermissionState("error");
                    if (process.env.REACT_APP_TEST_ENV !== 'development') {
                        setShowModal(true);
                    }
                    setError("Unable to check local network access permission in this browser.");
                }
            }
        }

        run();

        return () => {
            cancelled = true;
            if (status) status.onchange = null;
        };
    }, []);

    const close = () => setShowModal(false);

    return (
        <>
            {showModal && backdropRoot &&
                ReactDOM.createPortal(
                    <Backdrop hide={close} hideEnabled={true} onTop={true} />,
                    backdropRoot
                )}

            {showModal && overlayRoot &&
                ReactDOM.createPortal(
                    <Modal onTop={true}>
                        <div className={classes.modal_content}>
                            <h2 style={{ marginTop: 0 }}>Local network access required</h2>
                            <p>
                                It looks like you are experiencing an issue while trying to proceed accessing your account. This is most likely because your browser does not have the required permission enabled.
                            </p>
                            <p>To continue, please make sure to allow the permission when your browser asks for it.</p>
                            <img src={require('../../assets/permission1.jpg')} alt="Browser permission 1" />
                            <p>If you previously denied the permission and want to change your selection:</p>
                            <img src={require('../../assets/permission2.jpg')} alt="Browser permission 2" />
                            {/* <p style={{ marginBottom: 12 }}>
                                Current status: <b>{permissionState}</b>
                            </p>
                            {error && (
                                <p style={{ marginBottom: 12 }}>
                                    <b>Note:</b> {error}
                                </p> */}
                            {/* )} */}
                            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                <Button type="button" click={close} bypassisCaseArchived={true}>
                                    Close
                                </Button>
                            </div>
                        </div>
                    </Modal>,
                    overlayRoot
                )}

            {/* This component is intended to be mounted globally */}
            <div style={{ display: "none" }} />
        </>
    );
}